import {
	COUPON_FETCH,
	COUPON_FETCH_SUCCESS,
} from "../actions/types";

export const couponFetch = payload => {
	return {
		type: COUPON_FETCH,
		payload: payload
	};
};

export const couponFetchSuccess = payload => {
	return {
		type: COUPON_FETCH_SUCCESS,
		payload: payload
	};
};